import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const adminEventStatisticsSlice = (state: RootState) => state.entities.adminEventStatistics;

export const adminEventStatisticsUpdatingStateById =
  selectorsFactory.createUpdatingStateByIdSelector(adminEventStatisticsSlice);

export const adminEventStatisticsStateById = selectorsFactory.createEntityStateByIdSelector(adminEventStatisticsSlice);
